var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStarEmpty = function SvgStarEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.217 1.588c.568-1.154 2.268-1.116 2.76.115l1.882 4.7.012.01 5.037.342.125.014c1.233.179 1.724 1.713.838 2.58l-.093.084-3.874 3.247a.02.02 0 0 0-.006.02l1.232 4.91.026.123c.208 1.222-1.088 2.178-2.193 1.595l-.11-.063-4.275-2.693h-.013l-4.276 2.693c-1.162.732-2.607-.335-2.276-1.655l1.232-4.91-.006-.02-3.874-3.247c-1.043-.875-.496-2.585.87-2.678l5.037-.343.012-.01 1.881-4.699.052-.115Z",
    stroke: "#E4E9F1",
    strokeWidth: 1.5
  })));
};

export default SvgStarEmpty;